angular.module("ticketco/ticketbuyer/retrieve_tickets", [
  "ticketco/ticketbuyer/common"
]);
